__turbopack_context__.v({
  "autocomplete": "StockSearchView-module__i_fmuG__autocomplete",
  "clearIcon": "StockSearchView-module__i_fmuG__clearIcon",
  "copy": "StockSearchView-module__i_fmuG__copy",
  "fieldOpen": "StockSearchView-module__i_fmuG__fieldOpen",
  "hasSelections": "StockSearchView-module__i_fmuG__hasSelections",
  "inputSelected": "StockSearchView-module__i_fmuG__inputSelected",
  "logo": "StockSearchView-module__i_fmuG__logo",
  "logoPill": "StockSearchView-module__i_fmuG__logoPill",
  "name": "StockSearchView-module__i_fmuG__name",
  "option": "StockSearchView-module__i_fmuG__option",
  "optionFading": "StockSearchView-module__i_fmuG__optionFading",
  "options": "StockSearchView-module__i_fmuG__options",
  "searchIcon": "StockSearchView-module__i_fmuG__searchIcon",
  "selectedItems": "StockSearchView-module__i_fmuG__selectedItems",
  "selectedPill": "StockSearchView-module__i_fmuG__selectedPill",
  "status": "StockSearchView-module__i_fmuG__status",
  "symbol": "StockSearchView-module__i_fmuG__symbol",
  "trailing": "StockSearchView-module__i_fmuG__trailing",
});
